import defer from 'lodash/defer';
import { utils } from '@resy/ui-kitchen';

import { getVenue } from '../../../../ui-kitchen/src/api/api';
import { venueTransform } from '../../../../ui-kitchen/src/api/resyApiTransformer';
import { Logger, initObserveStore } from '../../../../ui-kitchen/src/utils';
import { getUserThunk, userLogoutThunk } from '../../../../ui-kitchen/src/reducers/userSlice';

(() => {
  angular
    .module('resyApp')
    .controller('EventDetailsCtrl', EventDetailsCtrl);

  function EventDetailsCtrl(
    $q,
    $rootScope,
    $scope,
    $location,
    $routeParams
  ) {
    /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["$scope"] }] */
    const thisCtrl = this;

    const globalWidgetConfig = {};

    const { checkIfType } = utils;
    const store = $rootScope.reduxStore;
    const { dispatch } = store;

    thisCtrl.venueSlug = $routeParams.venueSlug;
    thisCtrl.venueId = null;
    thisCtrl.locationSlug = $routeParams.location;
    thisCtrl.eventSlug = $routeParams.eventSlug;
    thisCtrl.selectResy = selectResy;
    thisCtrl.userIsGda = false;
    thisCtrl.isAuthenticated = false;
    thisCtrl.showAuthModal = showAuthModal;

    let prevUserData = null;
    const onUserSliceChange = (userSlice) => {
      const { userData } = userSlice;

      // Angular 'UserAuth' event handling
      if (prevUserData === null && userData) {
        thisCtrl.userIsGda = userData.is_global_dining_access;
        thisCtrl.isAuthenticated = true;
      }
      // Angular 'UserLogout' event handling
      if (prevUserData && userData === null) {
        thisCtrl.userIsGda = false;
        thisCtrl.isAuthenticated = false;
      }
      prevUserData = userData;
      defer(() => $scope.$apply());
    };

    const observeUserSlice = initObserveStore(store, ({ user }) => (user));
    const unsubscribeUserSlice = observeUserSlice(onUserSliceChange);

    $rootScope.$on('$destroy', () => {
      unsubscribeUserSlice();
    });

    onInit();

    dispatch(getUserThunk())
      .then((data) => {
        thisCtrl.userIsGda = data?.is_global_dining_access || false;
        thisCtrl.isAuthenticated = true;
        defer(() => $scope.$apply());
      });

    function onInit() {
      loadVenue();
    }

    function loadVenue() {
      getVenue({ url_slug: thisCtrl.venueSlug, location: thisCtrl.locationSlug })
        .then((response) => {
          const venue = venueTransform(response);
          thisCtrl.venueId = venue.id;
          if (venue?.enableDiscovery === 0) {
            $scope.metadata.robots = 'noindex';
          }
          buildWidgetConfig();
          defer(() => $scope.$apply());
        })
        .catch((error) => {
          Logger.error('[VenuePage] loadVenue() failure: ', error);
          if (error && error?.status === 419) {
            dispatch(userLogoutThunk());
          } else {
            $location.url('/');
          }
        });
    }

    function buildWidgetConfig() {
      const queryParams = $location.search();
      globalWidgetConfig.venueId = thisCtrl.venueId;
      globalWidgetConfig.venueSlug = thisCtrl.venueSlug;
      globalWidgetConfig.location = thisCtrl.locationSlug;
      globalWidgetConfig.eventSlug = thisCtrl.eventSlug;
      globalWidgetConfig.widgetPath = `cities/${thisCtrl.locationSlug}/venues/${thisCtrl.venueSlug}/events/${thisCtrl.eventSlug}`;
      globalWidgetConfig.src = 'resy.com-event-details';

      if (queryParams.reservation === 'true') {
        globalWidgetConfig.reservation = true;
      }
      if (checkIfType.isString(queryParams.date)) {
        globalWidgetConfig.date = queryParams.date;
      }
      if (checkIfType.isString(queryParams.seats)) {
        globalWidgetConfig.seats = queryParams.seats;
      }
      if (checkIfType.isString(queryParams.num_seats)) {
        globalWidgetConfig.seats = queryParams.num_seats;
      }
      if (checkIfType.isString(queryParams.party_size)) {
        globalWidgetConfig.seats = queryParams.party_size;
      }
      if (checkIfType.isString(queryParams.resyToken)) {
        globalWidgetConfig.resyToken = queryParams.resyToken;
      }
      if (checkIfType.isString(queryParams.aff_id)) {
        globalWidgetConfig.affId = queryParams.aff_id;
      }

      // google availability feed
      if (checkIfType.isString(queryParams.first_name)) {
        globalWidgetConfig.firstName = queryParams.first_name;
      }
      if (checkIfType.isString(queryParams.last_name)) {
        globalWidgetConfig.lastName = queryParams.last_name;
      }
      if (checkIfType.isString(queryParams.email_address)) {
        globalWidgetConfig.email = queryParams.email_address;
      }
      if (checkIfType.isString(queryParams.mobile_number)) {
        globalWidgetConfig.phone = queryParams.mobile_number;
      }
      if (checkIfType.isString(queryParams.reservation_date_time)) {
        // expecting ISO 8601 format in venue's local time
        // example: 1994-11-05T08:15:30-05:00
        globalWidgetConfig.date = queryParams.reservation_date_time.slice(0, 10);
        globalWidgetConfig.timeslot = queryParams.reservation_date_time.slice(11, 19);
      }

      // situations that need to launch the widget right away
      // link to user reservations
      // link to a table config (e.g. from notify)
      if ('reservation' in globalWidgetConfig) {
        /**
         * Clubhouse: 14225
         * The Manage/Change Reservation link from emails contains both the `reservation` and `resyToken` params.
         * The widget is build to load and go directly to Change/Cancel if
         * it is opened with the `resyToken` being present in the config and `reservation` not being present.
         * So we can support this by simply deleting the `reservation` property before opening.
         */
        if ('resyToken' in globalWidgetConfig) {
          delete globalWidgetConfig.reservation;
        }
        resyWidget.openModal(globalWidgetConfig);
      }

      // Resets
      $location.search('reservation', null).replace();
      delete globalWidgetConfig.reservation;
    }

    function selectResy({ reservationConfig, reservation, previewMode }) {
      if (previewMode) {
        globalWidgetConfig.previewMode = true;
      }
      const reservationPayload = {
        isEvent: true,
        venue: reservation.event?.venue,
        eventId: reservation.event?.eventid,
        title: reservation.event?.title,
        date: reservation.event?.date,
        isGda: reservation.isGda,
        hasMenus: reservation.hasMenus,
        price: reservation.price,
        templateId: reservation.templateId,
        time: reservation.time,
        token: reservation.token,
        type: reservation.type,
      };

      resyWidget.openModal({ ...globalWidgetConfig, ...reservationConfig }, reservationPayload);
    }

    function showAuthModal(successCallback) {
      $rootScope.$broadcast('MODAL', 'signin', { successCallback });
    }
  }
})();

export default () => {};
